import React, { Fragment } from "react";

import { ProvideAuth } from "hooks/Auth";
import { ProvideNotification } from "hooks/Notification";
import { ProvideModal } from "hooks/Modal";

const providers = [ProvideAuth, ProvideNotification, ProvideModal];

export function combineProviders(providers = []) {
    return providers.reduce(
        (ParentProvider, CurrentProvider) => {
            return ({ children }) => {
                return (
                    <ParentProvider>
                        <CurrentProvider>{children}</CurrentProvider>
                    </ParentProvider>
                );
            };
        },
        ({ children }) => <Fragment>{children}</Fragment>
    );
}

export const ApplicationContextProvider = combineProviders(providers);
